<template>
  <div class="container">
    <div class="bg_image" :class="{'bg_image_0':swipeIndex==0,}">
      <common-head></common-head>
      <div class="swipe_item_content">
        <p>{{$t('home.headTitle')}}</p>
        <p>{{$t('home.headContent')}}</p>
        <div @click="go('Profile')" v-show="$i18n.locale=='zh'">{{$t('home.headBtn')}}</div>
        <img :class="{'img_m_t':$i18n.locale=='en'}" src="../assets/images/logo.png" alt />
      </div>
    </div>
    <div class="bg_c_w">
      <business />
    </div>
    <div class="bg_c_g">
      <ai />
    </div>

    <div class="bg_c_w">
      <advantage />
    </div>
    <div class="bg_c_g">
      <moment />
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import commonHead from "../components/common-head.vue";
import business from "../components/home/business.vue";
import ai from "../components/home/ai.vue";
import advantage from "../components/home/advantage.vue";
import moment from "../components/home/moment.vue";
import commonFooter from "../components/common-footer.vue";
export default {
  data() {
    return {
      swipeIndex: 0
    };
  },
  components: {
    commonHead,
    business,
    ai,
    advantage,
    moment,
    commonFooter
  },
  created() {},
  methods: {
    go(name) {
      this.$router.push({ name });
    },
    handleSwipeChange(index) {
      this.swipeIndex = index;
    }
  }
};
</script>

<style lang="less" scoped>
h1 {
  text-align: center;
}
.bg_image_0 {
  background-image: url("../assets/images/banner_1.png");
}
.bg_image {
  height: 350px;
  background-image: url("../assets/images/banner_1.png");
  & .swipe_item_content {
    width: 100%;
    height: 295px;
    position: relative;
    animation: text_animation 4s;
    padding: 29px 20px 0;
    & p:nth-child(1) {
      font-size: 20px;
      color: #ff9200;
      margin-bottom: 5px;
    }
    & p:nth-child(2) {
      font-size: 12px;
      color: #ffffff;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-bottom: 31px;
    }
    & div:nth-child(3) {
      width: 77.5px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      background: #ff9200;
      font-size: 12px;
      color: #feffff;
      border-radius: 24px;
      margin-bottom: 47.55px;
    }
    & .img_m_t {
      margin-top: 71.55px;
    }
    & img:nth-child(4) {
      width: 235px;
      height: 42.5px;
    }
  }
}

@keyframes text_animation {
  0% {
    opacity: 0;
    transform: translateY(-431px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>